import { BackendAddress } from '@trucksmarter/shared';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import { formatCityAndState } from '../../../../../../../../utils/location';
import DallasText from '../../../../../../../_ui/Dallas/Text/DallasText';

type Props = {
  className?: string;
  address: BackendAddress;
};

export default function AddressCell({
  className,
  address: { city, state },
}: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasText variant="captionL">
        {formatCityAndState(city, state)}
      </DallasText>
    </DallasTableDataCell>
  );
}
